import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setPortal } from 'modules/portal';
import queryString from 'query-string';
import moment from 'moment';

import {
  makeRowColumn,
  getHeadObj,
  dataConverter,
  cenversionTpCode,
} from 'lib/commonLib';
import { localAdverReport } from 'lib/api/localreport';

import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

const AdverStatistics = ({ location }) => {
  // 통계보고서 - 지역타겟팅통계 - 일자별통계 sDate, eDate
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));

  const isPopPage = queryString.parse(location.search).isPop === '1';

  let initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    pltfomTpCode: 'all',
    itlTpCode: 'all',
    sumSub: 1,
    sDate: moment().add(-30, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
  };

  const convertKeys = ['sDate', 'eDate'];
  const newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );
  initParams = {
    ...initParams,
    ...newInitParams,
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  // header 및 body 컬럼 커스텀
  const customized = {
    SITE_NAME: {
      makeBody: (rowObj, headsMap) => {
        const showWindowUrl =
          '/report/local/day?uri=/report/local/day&adverId=' +
          rowObj['ADVER_ID'] +
          '&popGroup=local' +
          '&sDate=' +
          params.sDate +
          '&eDate=' +
          params.eDate +
          '&isPop=1';
        const itemObj = getHeadObj(headsMap, 'SITE_NAME');

        return rowObj.isChild && rowObj['SITE_NAME'] !== 'total' ? (
          cenversionTpCode(rowObj.PLTFOM_TP_CODE)
        ) : rowObj['SITE_NAME'] !== 'total' ? (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['SITE_NAME'],
              itemObj.type,
              itemObj.format
            )}
            icon="faExternalLink"
            toolTipTitle={t('해당 광고주의 지역타게팅 통계')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
            style={{ width: 200 }}
          />
        ) : (
          rowObj['SITE_NAME']
        );
      },
    },
    UM_PAR_EPRS_CNT: {
      makeHead: (headsMap) => {
        return t('성향');
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'UM_PAR_EPRS_CNT');
        return makeRowColumn(
          rowObj['UM_PAR_EPRS_CNT'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
    },
    AD_PAR_EPRS_CNT: {
      makeHead: (headsMap) => {
        return t('베이스광고');
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'AD_PAR_EPRS_CNT');
        return makeRowColumn(
          rowObj['AD_PAR_EPRS_CNT'],
          bodyItem1.type,
          bodyItem1.format
        );
      },
    },
    ADVER_ID: {
      makeBody: (rowObj, headsMap) => {
        return (
          rowObj['SITE_NAME'] !== 'total' &&
          !rowObj['isChild'] &&
          rowObj['ADVER_ID']
        );
      },
    },
    MEDIA_SCRIPT_CNT: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'MEDIA_SCRIPT_CNT');
        return (
          rowObj['SITE_NAME'] !== 'total' &&
          !rowObj['PLTFOM_TP_CODE'] &&
          !rowObj['isChild'] &&
          makeRowColumn(
            rowObj['MEDIA_SCRIPT_CNT'],
            bodyItem1.type,
            bodyItem1.format
          )
        );
      },
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
      if (isPopPage && window.location.search !== '?isPop=1') {
        window.location.replace(window.location.pathname + '?isPop=1');
      }
    }
  };

  /**
   * 페이지 파라미터를 관리하는 params을 수정하는 함수
   * @param newParams
   */
  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  /**
   * 테이블 클릭 후 세부정보 받아올때 보낼 param setting 해주는 함수
   * @param {json} data 테이블 로우 데이터
   */
  const makeSubParam = (data) => {
    return {
      adverId: data.ADVER_ID,
    };
  };

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = {
      url: url,
      cnt: popIndex,
    };
    dispatch(setPortal(newPortal));
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useExternalFilter={false}
        />
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={localAdverReport}
        makeSubParam={makeSubParam}
        customized={customized}
        expandTable
        useFetch={false}
        useTotalSubList
      />
    </>
  );
};

export default withRouter(AdverStatistics);
